/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description React Hook usePaginatedLocations
 */
import _ from 'lodash';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import api from 'client/index';
import { getParsedLocationDetails } from 'utils/admin/locations';
import { scrollToWidgetByHash } from '@veritable/common/utils';
import QUERY_KEYS from 'app-constants/queryKeys';
import { updateApiParamsCriteria } from 'utils/advancedFilterUtils';
import { LOCATION_ADF_FIELD_MAP } from 'utils/adfUtils';

interface IModel {
	pageNumber?: number;
	pageSize?: number;
	allLocations?: boolean;
	apiParams?: Location.IApiParams;
}

/**
 * Use Paginated Locations hook
 * @returns {UseQueryResult} usePaginatedLocations
 */
const usePaginatedLocations = (
	{ pageNumber, pageSize, allLocations = false, apiParams = {} }: IModel,
	options?: IQueryOptions,
): UseQueryResult<Location.Details, unknown> => {
	return useQuery({
		queryKey: [QUERY_KEYS.location, { apiParams, allLocations, pageNumber, pageSize }],
		queryFn: async () => {
			const { data } = await api.ServiceLocationDetailsApi.getPaginatedServiceLocationDetails({
				servicelocationSearchModel: updateApiParamsCriteria(_.cloneDeep(apiParams), LOCATION_ADF_FIELD_MAP),
				allLocations,
				pgNum: pageNumber,
				pgSize: pageSize,
			});
			setTimeout(scrollToWidgetByHash, 500);
			return {
				...data,
				data: _.map(data?.data, (location) => ({
					...location,
					...getParsedLocationDetails(location),
				})),
			};
		},
		...options,
	});
};

export default usePaginatedLocations;
